export default "__VITE_ASSET__2b39d335__"